import { render, staticRenderFns } from "./billSuccess.vue?vue&type=template&id=5bb16dfc&scoped=true&"
import script from "./billSuccess.vue?vue&type=script&lang=js&"
export * from "./billSuccess.vue?vue&type=script&lang=js&"
import style0 from "./billSuccess.vue?vue&type=style&index=0&id=5bb16dfc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb16dfc",
  null
  
)

export default component.exports